import React from 'react'
import { Splide, SplideSlide } from '@splidejs/react-splide';


export default function Splides() {
  const images = [
    {
      "url": "/images/image_01.png",
      "name": "Site map",
      "description": "Located in a quiet residential area by Lake Wanaka, the site is a great choice for long-term living. Beautiful walking path around the lake just 5 minutes walk. With just a 6-minute drive, you can reach the centre of Wanaka, where there are full services such as supermarkets, restaurants, coffee shops and schools..."
    },
    {
      "url": "/images/image_02.png",
      "name": "Concept",
      "description": "Kite De Modular is developed based on the idea of a sustainable and smart home for couples or small families. By minimizing details such as paving, deck, adding large windows and doors opening to the outside space, Kite brings the natural space closer to the house as possible."
    },
    {
      "url": "/images/image_03.png",
      "name": "Floor plan",
      "description": "Kite De Modular is developed based on the idea of a sustainable and smart home for couples or small families. By minimizing details such as paving, deck, adding large windows and doors opening to the outside space, Kite brings the natural space closer to the house as possible."
    },
    {
      "url": "/images/image_04.png",
      "name": "Module",
      "description": "Credit ArchDaily (https://www.archdaily.com/)"
    },
    {
      "url": "/images/image_05.png",
      "name": "Module",
      "description": "Credit ArchDaily (https://www.archdaily.com/)"
    },
    {
      "url": "/images/image_06.png",
      "name": "Living room",
      "description": "Hoop pine plywood used for lining gives a warm and relaxing feeling."
    },
    {
      "url": "/images/image_07.png",
      "name": "Kitchen",
      "description": "Hoop pine plywood used for lining gives a warm and relaxing feeling."
    },
    {
      "url": "/images/image_08.png",
      "name": "Bedroom",
      "description": "Hidden storages and build-in window seats are used to optimize floor space and provide a clean aesthetic while connecting residents with the outdoors."
    },
    {
      "url": "/images/image_09.png",
      "name": "Cross Section",
      "description": "External cladding uses charred timber from Abodo, this material is completely chemical free and highly durable while providing a modern and luxurious look."
    },
  ]
  return (
    <div className='position-relative w-100'>
      <Splide 
      options={{
        arrows: false,
        gap: "0",
        speed: "1000",
        autoplay: true,
        interval: 5000,
        rewind: "true",
        type: "fade",
        pauseOnHover: false,
        pauseOnFocus: false,
        classes: {
          page: 'splide__pagination__page bg-gold',
        }
      }}
      aria-label="Images">
        {
          images.map((el, i) => {
            return (
              <SplideSlide key={el.name} className='w-100'>
                <div className='position-relative'>
                  <div className='position-absolute w-75 top-0 start-0 px-4 py-4 d-flex flex-column'>
                    <h2 className='text-white text-shadow-sm fs-1 fw-light'>{el.name}</h2>
                    <p className='text-white d-none d-md-flex text-shadow-sm'>{el.description}</p>
                  </div>
                  <img style={{ objectFit: "cover" }} className='w-100' src={el.url} alt={`This is ${i}`}/>
                </div>
              </SplideSlide>
            )
          })
        }
      </Splide>
    </div>
  )
}
